export default __webpack_public_path__ + "static/media/quiz.34f750ce.svg";